import axios from 'axios';
import { call, all, put, takeLatest, select } from 'redux-saga/effects';

import * as auditUserActions from './audit-user-actions';

import { GET_LIST_ALL_AUDIT_USER_REQUEST } from './audit-user-constants';

import auditUserService from './audit-user-service';

import { ISA_ERROR } from '~/constants';

import { AppStateType } from '../root-reducer';

let cancel: any;
const CancelToken = axios.CancelToken;

export function* getAllAuditUser({ type }) {
  if (cancel !== undefined) cancel();
  const cancelToken = new CancelToken(function executor(c) {
    cancel = c;
  });

  try {
    yield put(auditUserActions.setLoadingData(true));

    const { rowsPerPage, page, order, orderBy } = yield select((state: AppStateType) => state.auditUser.list);

    const params = {
      skip: page === 0 ? 0 : page * rowsPerPage,
      limit: rowsPerPage,
      order,
      orderBy,
      entity: 'user'
    };

    const [{ data: auditUsers }, { data: rowsCount }] = yield all([
      call(
        auditUserService.getListAllAuditUserLog,
        {
          ...params
        },
        {
          cancelToken
        }
      ),
      call(auditUserService.getRowCount, {
        entity: 'user'
      })
    ]);

    yield put(
      auditUserActions.getAllAuditUserSuccess({
        auditUsers,
        rowsCount: rowsCount.count
      })
    );
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  } finally {
    yield put(auditUserActions.setLoadingData(false));
  }
}

export default all([takeLatest(GET_LIST_ALL_AUDIT_USER_REQUEST, getAllAuditUser)]);
